import type { WebhookEvent } from 'src/types/webhook'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

type TestWebhookRequest = {
  webhookId: string
  event: WebhookEvent
}

const useTestWebhookMutation = () => {
  const account = useAccount()

  return useMutation(
    async ({ webhookId, event }: TestWebhookRequest) => {
      const response = await api.post(`/webhooks/account/${account.id}/webhooks/${webhookId}/test`, { event })
      return response.data
    },
    {
      mutationKey: ['testWebhook'],
      successMessage: 'Test event queued',
      errorMessage: 'Failed to queue test event'
    }
  )
}

export default useTestWebhookMutation
